import { render, staticRenderFns } from "./StaffDashboardView.vue?vue&type=template&id=7b2c7a88&scoped=true"
import script from "./StaffDashboardView.vue?vue&type=script&lang=js"
export * from "./StaffDashboardView.vue?vue&type=script&lang=js"
import style0 from "./StaffDashboardView.vue?vue&type=style&index=0&id=7b2c7a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c7a88",
  null
  
)

export default component.exports